import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { HString } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-cmr-qr-page',
    templateUrl: './shared.external.cmr.qr.page.html',
    styleUrls: ['./shared.external.cmr.qr.page.scss']
})
export class SharedExternalCMRQRPage implements OnInit {


    public useIonic: boolean = false;
    constructor(public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController) {

        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    public uuidQR: string = "";
    ngOnInit(): void {
         this.activatedRoute.params.subscribe(a => {
            this.uuidQR = a.uuidQR;
        });
    }

    onClickQR(){
        if (!HString.isNullOrNullString(this.uuidQR)){
            this.homeController.routeToExternalCMRsUUIDQR(this.uuidQR);
        }
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
